<template>
  <div
    :style="{ top: top + 'px', left: left + 'px' }"
    @touchstart="touchstart"
    @touchmove="touchmove"
    class="drag-wrap"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      top: '',
      left: '',
      offsetWidth: 0,
      offsetHeight: 0,
      screenWidth: 0,
      screenHeight: 0,
      actOffset: [0, 0, 0, 0],
      height: 0,
      width: 0
    }
  },
  props: {
    lockedX: {
      // 锁定X轴
      type: Boolean,
      default: false
    },
    lockedY: {
      // 锁定Y轴
      type: Boolean,
      default: false
    },
    offset: {
      // 默认偏移量
      type: Array,
      default: () => {
        return [0, 0, 0, 0] // 上，右，下，左
      }
    }
  },
  methods: {
    // 兼容没有event.path
    composedPath(e) {
      if (e.path) {
        return e.path
      }
      let target = e.target
      e.path = []
      while (target.parentNode !== null) {
        e.path.push(target)
        target = target.parentNode
      }
      return e.path
    },
    touchstart(e) {
      // e.stopPropagation();
      // e.preventDefault();
      this.offsetHeight =
        e.targetTouches[0].clientY - e.target.getBoundingClientRect().y
      this.offsetWidth =
        e.targetTouches[0].clientX - e.target.getBoundingClientRect().x
      this.height = this.getDragDom(e).offsetHeight
      this.width = this.getDragDom(e).offsetWidth
    },
    touchmove(e) {
      e.stopPropagation()
      e.preventDefault()
      if (!this.lockedX) {
        this.left = Math.max(
          Math.min(
            this.screenWidth - this.actOffset[1] - this.width,
            e.targetTouches[0].clientX - this.offsetWidth
          ),
          this.actOffset[3]
        )
      }
      if (!this.lockedY) {
        this.top = Math.max(
          Math.min(
            this.screenHeight - this.actOffset[2] - this.height,
            e.targetTouches[0].clientY - this.offsetHeight
          ),
          this.actOffset[0]
        )
      }
    },
    // 获取第一个class包含drag-wrap的节点
    getDragDom(event) {
      return this.composedPath(event).filter(item => {
        return item.className
          ? item.className.indexOf('drag-wrap') !== -1
          : false
      })[0]
    }
  },
  mounted() {
    this.screenWidth = document.getElementsByTagName('html')[0].clientWidth
    this.screenHeight = document.getElementsByTagName('html')[0].clientHeight
    let arr = []
    if (this.offset.length < 4) {
      arr = [...this.offset, ...new Array(4 - this.offset.length).fill(0)]
    } else {
      arr = this.offset.splice(0, 4)
    }
    arr = arr.map((item, index) => {
      if (index % 2 === 0) {
        item = Math.min(Math.max(item, 0), this.screenHeight)
      } else {
        item = Math.min(Math.max(item, 0), this.screenWidth)
      }
      return item
    })
    this.actOffset = arr
  }
}
</script>
<style lang="scss" scoped>
.drag-wrap {
  // width: 100px;
  // height: 40px;
  // background: lightgrey;
  z-index: 1000;
}
</style>
